import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { lazy, useEffect, useReducer } from "react";
import { ToastContainer } from "react-toastify";
import reducer, { loadState, saveState } from "./controllers/reducer";
import { Context } from "./components/utils";
import "./i18n";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "react-tabs/style/react-tabs.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/bootstrap/bootstrap.min.css";
import "@/styles/App.scss";
import SuspenseLoad from "./components/SuspenseLoad";
import ProfileLayout from "./pages/profile";
import InitialLoadData from "./InitialLoadData";
import Home from "./pages/home";
import Layout from "./components/Layout";
import Login from "./pages/login";
import Referral from "./pages/login/Referral";
import Shops from "./pages/shops";
import Rates from "./pages/rates";
import Help from "./pages/help";
import Services from "./pages/servicess";
import Contacts from "./pages/contacts";
const NewOrder = lazy(() => import("./pages/new-order"));
const UserTrackings = lazy(
  () => import("./pages/profile/trackings/UserTrackings")
);
const UserShopOrders = lazy(
  () => import("./pages/profile/shops/UserShopOrders")
);
const UserOrders = lazy(() => import("./pages/profile/orders/UserOrders"));
const UserParcels = lazy(() => import("./pages/profile/UserParcels"));
const ShopOrder = lazy(() => import("./pages/profile/shops/ShopOrder"));

const TrackingOrder = lazy(
  () => import("./pages/profile/trackings/TrackingOrder")
);
const UserBalance = lazy(() => import("@/pages/profile/UserBalance"));
const UserCabinetMain = lazy(() => import("@/pages/profile/UserCabinetMain"));

////
const UserSettings = lazy(() => import("./pages/profile/UserSettings"));
const UserAddresses = lazy(() => import("./pages/profile/UserAddresses"));
const UserOrder = lazy(() => import("@/pages/profile/orders/Order"));

function App() {
  const [state, dispatch] = useReducer(reducer, loadState());

  useEffect(() => {
    saveState(state);
  }, [state]);

  return (
    <Context.Provider value={{ state, dispatch }}>
      <Router basename="/">
        <InitialLoadData>
          <ToastContainer />
          <Layout>
            <Routes>
              <Route path="/" Component={Home} />
              <Route path="/referral/:referral" Component={Referral} />
              <Route path="/login" Component={Login} />
              <Route path="/shops" Component={Shops} />
              <Route path="/rates" Component={Rates} />
              <Route path="/help" Component={Help} />
              <Route path="/services" Component={Services} />
              <Route path="/contacts" Component={Contacts} />
              <Route
                path="/new-order"
                element={
                  <SuspenseLoad>
                    <NewOrder />
                  </SuspenseLoad>
                }
              />
              <Route path="*" element={<ProfileLayout />}>
                <Route
                  path="profile"
                  element={
                    <SuspenseLoad>
                      <UserCabinetMain />
                    </SuspenseLoad>
                  }
                />
                <Route
                  path="parcels"
                  element={
                    <SuspenseLoad>
                      <UserParcels />
                    </SuspenseLoad>
                  }
                >
                  <Route
                    path="orders"
                    element={
                      <SuspenseLoad>
                        <UserOrders />
                      </SuspenseLoad>
                    }
                  />
                  <Route
                    path="trackings"
                    element={
                      <SuspenseLoad>
                        <UserTrackings />
                      </SuspenseLoad>
                    }
                  />
                  <Route
                    path="shop-orders"
                    element={
                      <SuspenseLoad>
                        <UserShopOrders />
                      </SuspenseLoad>
                    }
                  />
                </Route>
                <Route
                  path="parcels/orders/:id"
                  element={
                    <SuspenseLoad>
                      <UserOrder />
                    </SuspenseLoad>
                  }
                />
                <Route
                  path="parcels/shop-orders/:id"
                  element={
                    <SuspenseLoad>
                      <ShopOrder />
                    </SuspenseLoad>
                  }
                />
                <Route
                  path="parcels/trackings/:id"
                  element={
                    <SuspenseLoad>
                      <TrackingOrder />
                    </SuspenseLoad>
                  }
                />
                <Route
                  path="addresses"
                  element={
                    <SuspenseLoad>
                      <UserAddresses />
                    </SuspenseLoad>
                  }
                />
                <Route
                  path="balance"
                  element={
                    <SuspenseLoad>
                      <UserBalance />
                    </SuspenseLoad>
                  }
                />
                <Route
                  path="settings"
                  element={
                    <SuspenseLoad>
                      <UserSettings />
                    </SuspenseLoad>
                  }
                />
              </Route>
            </Routes>
          </Layout>
        </InitialLoadData>
      </Router>
    </Context.Provider>
  );
}

export default App;
